var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import useUniqueId from "../../Hooks/useUniqueId";
const Checkbox = (_a, 
// @ts-expect-error - TS7006 - Parameter 'ref' implicitly has an 'any' type.
ref) => {
    var { id, label, checked, isInvalid, inline, className, invalidMessage, title, disabled, onChecked, onChange, helpText } = _a, otherProps = __rest(_a, ["id", "label", "checked", "isInvalid", "inline", "className", "invalidMessage", "title", "disabled", "onChecked", "onChange", "helpText"]);
    const makeId = useUniqueId()[1];
    const safeId = id || makeId("checkbox");
    return (_jsxs("div", { className: classNames("custom-control custom-checkbox", {
            "custom-control-inline": inline,
        }, { disabled }), title: title, children: [_jsx("input", Object.assign({}, otherProps, { onChange: (e) => {
                    if (onChange) {
                        onChange(e);
                    }
                    if (onChecked) {
                        onChecked(e.target.checked);
                    }
                }, ref: ref, type: "checkbox", id: safeId, checked: checked, className: classNames("custom-control-input", {
                    [className || ""]: !!className,
                    "is-invalid": isInvalid,
                }), disabled: disabled })), _jsx("label", { className: "custom-control-label", htmlFor: safeId, children: label }), helpText && (_jsx("div", { children: _jsx("small", { children: helpText }) })), invalidMessage && (_jsx("div", { className: "invalid-feedback", children: invalidMessage }))] }));
};
export default React.forwardRef(Checkbox);
